import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { callToActionUrl } from 'src/app/shared/constants/general.constants';
import { IUser } from 'src/app/shared/models/IUser.model';
import { LanguageService, AuthService, HelpersService } from '@evento-ng/libs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  public isMenuCollapsed = true;
  user: IUser;
  navItems = [
    {
      title: 'Home',
      route: '/home',
    },
    {
      title: 'Events',
      route: '/events',
    },
    {
      title: 'Matches',
      route: '/matches',
    },
    {
      title: 'about us',
      route: '/about-us',
    },
    {
      title: 'Services',
      external: true,
    },
    {
      title: 'Contact Us',
      route: '/contact-us',
    },
    {
      title: 'Terms',
      route: '/policy',
    },
    {
      title: 'Admin',
      route: '/business',
      authorized: true,
      dashboard: true,
    },
    {
      title: 'Dashboard',
      route: '/business',
      authorized: true,
      dashboard: true,
    },
  ];
  constructor(
    private languageService: LanguageService,
    private authService: AuthService,
    public translate: TranslateService,
    public helpers: HelpersService
  ) {
    this.user = this.helpers.getUserFromToken();
  }
  public onSwitchLanguages(): void {
    this.languageService.switchLanguages();
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => {},
      error: (err) => {
        console.error('Logout error:', err);
      },
    });
  }

  navigateToExternal(event: MouseEvent) {
    event.preventDefault();

    window.location.href = callToActionUrl;
  }

  navigateToDashboard(event: MouseEvent) {
    event.preventDefault();
    window.location.href = window.location.origin + '/business/';
  }
}
